/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProfileStatus = {
    Active: 'ACTIVE',
    Deleted: 'DELETED',
    Suspended: 'SUSPENDED'
} as const;
export type ProfileStatus = typeof ProfileStatus[keyof typeof ProfileStatus];

